<template>
  <footer
    class="border-t border-white/10 bg-slate-900 px-6 py-12 text-slate-400 md:px-10"
  >
    <div
      class="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:justify-between"
    >
      <div class="max-w-md">
        <img
          src="/assets/rtc-logo-dark-transparent.png"
          alt="RTC4Water — Real-Time Control of Water Infrastructure"
          class="h-14 w-auto"
        />
        <p class="mt-4 text-sm leading-6">
          62A, Grand Rue · L-3394 Roeser · Luxembourg
        </p>
        <p class="mt-2 text-sm">
          {{ $t("footer.vat") }}: LU27316928 · {{ $t("footer.matricule") }}:
          20142463459
        </p>
        <p class="mt-2 text-sm">
          <a
            href="mailto:info@rtc4water.com"
            class="text-rtcblue-300 transition hover:text-rtcblue-200"
            >info@rtc4water.com</a
          >
          ·
          <a
            href="tel:+35224836976"
            class="text-rtcblue-300 transition hover:text-rtcblue-200"
            >+352 24 83 69 76</a
          >
        </p>
      </div>

      <nav
        class="grid grid-cols-2 gap-x-10 gap-y-2 text-sm sm:grid-cols-3 md:text-right"
      >
        <router-link to="/" class="transition hover:text-white">{{
          $t("nav.home")
        }}</router-link>
        <router-link to="/platform" class="transition hover:text-white">{{
          $t("nav.platform")
        }}</router-link>
        <router-link to="/solutions" class="transition hover:text-white">{{
          $t("nav.solutions")
        }}</router-link>
        <router-link to="/projects" class="transition hover:text-white">{{
          $t("nav.projects")
        }}</router-link>
        <router-link to="/about" class="transition hover:text-white">{{
          $t("nav.about")
        }}</router-link>
        <router-link to="/contact" class="transition hover:text-white">{{
          $t("nav.contact")
        }}</router-link>
      </nav>
    </div>

    <div
      class="mx-auto mt-10 flex max-w-7xl flex-col gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between"
    >
      <p>
        © {{ year }} RTC4Water S.à r.l. · Luxembourg ·
        {{ $t("footer.rights") }}.
      </p>
      <div class="flex gap-5">
        <a href="#" class="transition hover:text-white">{{
          $t("footer.imprint")
        }}</a>
        <a href="#" class="transition hover:text-white">{{
          $t("footer.privacy")
        }}</a>
        <a href="#" class="transition hover:text-white">{{
          $t("footer.terms")
        }}</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",

  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
